<template>
    <div class="sf-grants-list">
        <slot />
    </div>
</template>

<script>
export default {

};
</script>

<style lang="less" src="./grants-list.less" />
